import { inject, Pipe, PipeTransform } from '@angular/core';
import { CurrencySymbolsService } from '../../services/currency-symbols/currency-symbols.service';

@Pipe({
  name: 'currencySymbol',
  standalone: true,
})
export class CurrencySymbolPipe implements PipeTransform {
  public currencySymbolService = inject(CurrencySymbolsService);

  transform(currencyCode: string): string {
    const CurrencySymbol = this.currencySymbolService.currencySymbols();
    const symbol = currencyCode in CurrencySymbol ? CurrencySymbol[currencyCode] : currencyCode;

    // block/strip SVG
    if (typeof symbol === 'string' && symbol.trim().startsWith('<svg')) {
      return currencyCode;
    }

    return symbol;
  }
}
